import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { EventsService } from '../services';
import { EVENTS_API_URL } from '../tokens';

export function provideEventsApi(baseUrl: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    EventsService,
    { provide: EVENTS_API_URL, useValue: baseUrl }
  ]);
}
